import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlusIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Path_6824",
		"data-name": "Path 6824",
		d: "M18,13H13v5a1,1,0,0,1-2,0V13H6a1,1,0,0,1,0-2h5V6a1,1,0,0,1,2,0v5h5a1,1,0,0,1,0,2Z",
		transform: "translate(-5 -5)",
		fill: "#fff"
	})
});
export { SvgPlusIcon as ReactComponent };
